import { createContext, useContext, useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import { useAdminAuth } from "./AdminAuthContext";
import toast from "react-hot-toast";
import NotificationToast from "../components/common/NotificationToast";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const { admin } = useAdminAuth();
    const adminId = admin?._id || admin?.id;

    const [notifications, setNotifications] = useState([]);
    const [unreadBookingIds, setUnreadBookingIds] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);

    const socketRef = useRef(null);

    useEffect(() => {
        if (!adminId) return;

        const socket = io(process.env.REACT_APP_BACKEND_BASE_URL, {
            transports: ["websocket"],
            withCredentials: true,
        });
        socketRef.current = socket;

        socket.on("connect", () => {
            // console.log("🟢 Frontend connected:", socket.id);

            // join personal room
            socket.emit("join", { userId: adminId });
        });


        //  LISTEN HERE (single source)
        socket.on("new_notification", (notif) => {
            // console.log("📩 Live:", notif);

            setNotifications((prev) => [notif, ...prev]);
            setUnreadCount((prev) => prev + 1);

            //  EXTRACT bookingId
            const bookingId = notif?.data?.bookingId;

            if (bookingId && !notif.isRead) {
                setUnreadBookingIds((prev) => {
                    if (prev.includes(bookingId)) return prev;
                    return [bookingId, ...prev];
                });            }
                
            // SHOW TOAST
            toast.custom(
                (t) => (
                    <div
                        style={{
                            transform: t.visible ? "scale(1)" : "scale(0.95)",
                            opacity: t.visible ? 1 : 0,
                            transition: "all 0.2s ease",
                        }}
                    >
                        <NotificationToast
                            title={notif.title || "New Notification"}
                            message={notif.message || ""}
                        />
                    </div>
                ),
                {
                    position: "top-right",
                }
            );
        });

        return () => {
            socket.disconnect();
        };
    }, [adminId]);

    return (
        <NotificationContext.Provider
            value={{
                notifications,
                setNotifications,
                unreadCount,
                setUnreadCount,
                unreadBookingIds,    
                setUnreadBookingIds
            }}
        >
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotifications = () => useContext(NotificationContext);